const configs = {
    "url_prod": "https://apiboletodigital.flexcontact.com.br/",
    "url_test": "https://apiboletodigital.xlab.work/",
    // "url_dev": "https://2298099b2209.ngrok.io/"
    "url_dev": "http://localhost:9018/"
    // "url_dev": "http://10.10.120.49:9018/"
}

export default configs;